export default __webpack_public_path__ + "static/media/138.b48192e4.png";